import React from "react";
import { useSelected, useFocused } from "slate-react";
import "./ImageElement.css"; // 共用樣式

const LinkElement = ({ attributes, children, element }) => {
  const { url } = element;
  const selected = useSelected();
  const focused = useFocused();

  const handleClick = (event) => {
    // 僅在 Ctrl (Windows) 或 Cmd (Mac) + 點擊時開啟連結
    if ((event.metaKey || event.ctrlKey) && url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
    // 其他情況下不阻止預設行為，讓 Slate 編輯器正常編輯
  };

  return (
    <a
      {...attributes}
      href={url}
      onClick={handleClick}
      className={`link-element ${selected && focused ? "focused-link" : ""}`}
      // 可選：加上 title 提示
      title="Ctrl (或 Cmd) + 點擊可開啟連結"
    >
      {children}
    </a>
  );
};

export default LinkElement;